<div class="d-flex justify-content-between align-items-center">
  <h2 mat-dialog-title>
    {{ "FILTER_STORE.STORED_FILTERS_TITLE" | translate }}
  </h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="my-4">
  <div
    *ngIf="(storedFiltersLoading$ | async) === true; else loaded"
    class="spinner-container"
  >
    <mat-spinner
      color="primary"
      diameter="40"
      mode="indeterminate"
    ></mat-spinner>
  </div>
  <ng-template #loaded>
    <ng-container
      *ngIf="((storedFilters$ | async)?.length ?? 0) > 0; else noFilters"
    >
      <ng-container *ngFor="let filter of storedFilters$ | async">
        <div
          class="flex space-between center filter-container"
          [style.background-color]="
            (selectedStoredFilterId$ | async) === filter.id ? '#D3D3D3' : ''
          "
          (click)="applyFilter(filter.id)"
        >
          <p>{{ filter.name }}</p>
          <div class="flex gap-2">
            <button
              *ngIf="filter.pinned; else notPinned"
              class="filter-action-btns pinned"
              (click)="togglePinOnFilter($event, filter.id)"
              [matTooltip]="'FILTER_STORE.UNPIN_FILTER' | translate"
            >
              <mat-icon fontSet="material-icons-outlined"> push_pin </mat-icon>
            </button>
            <ng-template #notPinned>
              <button
                class="filter-action-btns"
                (click)="togglePinOnFilter($event, filter.id)"
                [matTooltip]="'FILTER_STORE.PIN_FILTER' | translate"
              >
                <mat-icon fontSet="material-icons-outlined">
                  push_pin
                </mat-icon>
              </button>
            </ng-template>
            <button
              class="filter-action-btns delete"
              (click)="deleteFilter($event, filter.id)"
              [matTooltip]="'FILTER_STORE.DELETE_FILTER' | translate"
            >
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #noFilters>
      {{ "FILTER_STORE.NO_STORED_FILTERS" | translate }}
    </ng-template>
  </ng-template>
</div>
